import React, { useState } from 'react';
import '../styles/Navigation.css';
import { useLanguage } from '../contexts/LanguageContext';
import { Globe } from 'lucide-react';

interface NavigationProps {
  scrolled: boolean;
}

const Navigation: React.FC<NavigationProps> = ({ scrolled }) => {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const { language, setLanguage, t } = useLanguage();

  const scrollToSection = (sectionId: string) => {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
    setMobileMenuOpen(false);
  };

  return (
    <nav className={`navigation ${scrolled ? 'scrolled' : ''}`}>
      <div className="nav-container">
        <div className="nav-brand">
          <img src="/mozmina_icon_simple.png" alt="Mozmina" className="brand-icon" />
          <span className="brand-text">Mozmina</span>
        </div>
        
        <div className={`nav-links ${mobileMenuOpen ? 'mobile-open' : ''}`}>
          <button onClick={() => scrollToSection('home')}>{t('nav.home')}</button>
          <button onClick={() => scrollToSection('features')}>{t('nav.features')}</button>
          <button onClick={() => scrollToSection('management-center')}>{t('nav.modules')}</button>
          <button onClick={() => scrollToSection('benefits')}>{t('nav.benefits')}</button>
          <button onClick={() => scrollToSection('technology')}>{t('nav.technology')}</button>
          <button onClick={() => scrollToSection('contact')}>{t('nav.contact')}</button>
          
          {/* Language Toggle */}
          <div className="language-toggle">
            <Globe className="globe-icon" />
            <select 
              value={language} 
              onChange={(e) => setLanguage(e.target.value as 'en' | 'pt')}
              className="language-select"
            >
              <option value="en">EN</option>
              <option value="pt">PT</option>
            </select>
          </div>
          
          <button className="nav-cta">{t('hero.button.start')}</button>
        </div>
        
        <button 
          className="mobile-menu-toggle"
          onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
        >
          <span></span>
          <span></span>
          <span></span>
        </button>
      </div>
    </nav>
  );
};

export default Navigation;